import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_PERIODOS_ACADEMICOS = 'ALL_PERIODOS_ACADEMICOS';
export const ACTIVO_PERIODOS_ACADEMICOS = 'ACTIVO_PERIODOS_ACADEMICOS';
export const LOADING_ALL_PERIODOS_ACADEMICOS =
  'LOADING_ALL_PERIODOS_ACADEMICOS';
export const PARAMS_PERIODOS_ACADEMICOS = 'PARAMS_PERIODOS_ACADEMICOS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const periodosAcademicosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PERIODOS_ACADEMICOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_PERIODOS_ACADEMICOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_PERIODOS_ACADEMICOS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_PERIODOS_ACADEMICOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
